import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";

interface ImportParserModalProps {
  importParserOpen: boolean;
  onClose: () => void;
  data: any;
}

export const ImportParserModal = ({
  importParserOpen,
  onClose,
  data,
}: ImportParserModalProps) => {
  return (
    <Dialog open={importParserOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Custom Entity Attributes</DialogTitle>
        </DialogHeader>

        <div className="max-h-[500px] overflow-y-auto">
          <table className="w-full text-sm border border-border border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-border px-4 py-3 text-left">
                  Value
                </th>
              </tr>
            </thead>

            <tbody>
              {data &&
                Object.entries(data).map(([key, value]) => (
                  <tr key={key} className="hover:bg-gray-50">
                    <td className="border border-border px-4 py-3 break-all">
                      {String(value)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
};
